import { FC } from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
export interface CbFullWidthContainerProps extends BoxProps {
  backgroundColor?: string;
  borderColor?: string;
}
export const CbFullWidthContainer: FC<CbFullWidthContainerProps> = ({
  backgroundColor = 'cloud.100',
  borderColor = 'cloud.400',
  children,
  ...props
}) => {
  return <Box position="relative" paddingY={10} {...props} data-sentry-element="Box" data-sentry-component="CbFullWidthContainer" data-sentry-source-file="CbFullWidthContainer.tsx">
      <Box backgroundColor={backgroundColor} borderTop="1px solid" borderBottom="1px solid" borderColor={borderColor} position="absolute" top="0" bottom="0" left="50%" width="100vw" transform="translateX(-50vw)" data-sentry-element="Box" data-sentry-source-file="CbFullWidthContainer.tsx" />
      <Box position="relative" data-sentry-element="Box" data-sentry-source-file="CbFullWidthContainer.tsx">{children}</Box>
    </Box>;
};